import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import './DateIdeasNotepad.css';

const DateIdeasNotepad = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/date-ideas');
  };

  return (
    <motion.div
      className="date-ideas-notepad"
      whileHover={{ scale: 1.08, rotate: 3 }}
      whileTap={{ scale: 0.95 }}
      onClick={handleClick}
      title="Click to view date ideas"
    >
      <svg
        className="date-ideas-notepad-svg"
        viewBox="0 0 120 140"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Notepad body - soft pastel yellow */}
        <rect
          x="8"
          y="8"
          width="104"
          height="124"
          fill="#fef9e7"
          stroke="#e8d4a0"
          strokeWidth="2"
          rx="4"
        />

        {/* Spiral binding at top */}
        <g className="spiral-binding">
          {[...Array(8)].map((_, i) => (
            <circle
              key={i}
              cx={18 + i * 12}
              cy="14"
              r="3"
              fill="#c9a86c"
              opacity="0.7"
            />
          ))}
        </g>

        {/* Yellow flower decorations */}
        {/* Flower 1 - top left */}
        <g className="flower flower-1" transform="translate(20, 28)">
          <circle cx="0" cy="-6" r="4" fill="#ffe066" />
          <circle cx="5" cy="-3" r="4" fill="#ffe066" />
          <circle cx="5" cy="3" r="4" fill="#ffe066" />
          <circle cx="0" cy="6" r="4" fill="#ffe066" />
          <circle cx="-5" cy="3" r="4" fill="#ffe066" />
          <circle cx="-5" cy="-3" r="4" fill="#ffe066" />
          <circle cx="0" cy="0" r="4" fill="#ffb347" />
        </g>

        {/* Flower 2 - top right */}
        <g className="flower flower-2" transform="translate(100, 32)">
          <circle cx="0" cy="-5" r="3.5" fill="#fff176" />
          <circle cx="4" cy="-2" r="3.5" fill="#fff176" />
          <circle cx="4" cy="3" r="3.5" fill="#fff176" />
          <circle cx="0" cy="5" r="3.5" fill="#fff176" />
          <circle cx="-4" cy="3" r="3.5" fill="#fff176" />
          <circle cx="-4" cy="-2" r="3.5" fill="#fff176" />
          <circle cx="0" cy="0" r="3" fill="#ffa726" />
        </g>

        {/* Flower 3 - bottom right */}
        <g className="flower flower-3" transform="translate(95, 115)">
          <circle cx="0" cy="-4" r="3" fill="#ffe066" />
          <circle cx="3.5" cy="-2" r="3" fill="#ffe066" />
          <circle cx="3.5" cy="2" r="3" fill="#ffe066" />
          <circle cx="0" cy="4" r="3" fill="#ffe066" />
          <circle cx="-3.5" cy="2" r="3" fill="#ffe066" />
          <circle cx="-3.5" cy="-2" r="3" fill="#ffe066" />
          <circle cx="0" cy="0" r="2.5" fill="#ffb347" />
        </g>

        {/* Sparkle decorations */}
        <g className="sparkles">
          <path className="sparkle sparkle-1" d="M 45 30 L 47 35 L 45 40 L 43 35 Z" fill="#ffd54f" opacity="0.8" />
          <path className="sparkle sparkle-2" d="M 75 45 L 76.5 48.5 L 75 52 L 73.5 48.5 Z" fill="#ffeb3b" opacity="0.7" />
          <path className="sparkle sparkle-3" d="M 30 100 L 31.5 103.5 L 30 107 L 28.5 103.5 Z" fill="#ffc107" opacity="0.8" />
          <path className="sparkle sparkle-4" d="M 85 85 L 86 87.5 L 85 90 L 84 87.5 Z" fill="#ffeb3b" opacity="0.6" />
        </g>

        {/* "Date Ideas" text - handwritten style */}
        <text
          x="60"
          y="68"
          textAnchor="middle"
          fill="#8b6914"
          fontSize="13"
          fontFamily="var(--font-handwriting)"
          fontWeight="bold"
        >
          Date
        </text>
        <text
          x="60"
          y="88"
          textAnchor="middle"
          fill="#8b6914"
          fontSize="13"
          fontFamily="var(--font-handwriting)"
          fontWeight="bold"
        >
          Ideas
        </text>

        {/* Small heart decoration */}
        <path
          className="heart"
          d="M 60 98 Q 56 94 52 98 Q 48 102 52 106 L 60 113 L 68 106 Q 72 102 68 98 Q 64 94 60 98 Z"
          fill="#ffb6c1"
          opacity="0.8"
        />

        {/* Paper texture overlay */}
        <rect
          x="8"
          y="8"
          width="104"
          height="124"
          fill="url(#dateNotepadTexture)"
          opacity="0.2"
          rx="4"
        />

        <defs>
          <pattern id="dateNotepadTexture" x="0" y="0" width="4" height="4" patternUnits="userSpaceOnUse">
            <rect width="4" height="4" fill="transparent" />
            <circle cx="2" cy="2" r="0.5" fill="#c9a86c" opacity="0.3" />
          </pattern>
        </defs>
      </svg>
    </motion.div>
  );
};

export default DateIdeasNotepad;
